export enum Selects {
  NO_VARIETY = 'NO_VARIETY',
  ALL_VARIETIES = 'ALL_VARIETIES',
  ALL_CROPS = 'ALL_CROPS',
}

export type SatelliteProviders = 'ALL' | 'SENTINEL2' | 'PLANET' | 'LANDSAT89'
